
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { openFlutterBroadcastModal } from "./redux/slices/componentSlice/flutterBroadcastModalSlice";
import {
  applyOrderTypeFromUrl,
  applyQuickAssistTicketId,
  getNotificationLandingUrl,
} from "./helper/notificationOrderType";

const REDIRECT_ONLY_NOTIFICATION_TYPES = new Set([
  "background",
  "background_tap",
  "terminated_tap",
]);

function normalizeFlutterFCMNotificationDetail(detail) {
  let raw = detail;
  if (raw == null) return null;
  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      return null;
    }
  }
  if (typeof raw !== "object") return null;
  const src = raw.data && typeof raw.data === "object" ? raw.data : raw;
  return {
    image: src.image,
    context: src.context ?? "Broadcast",
    logo: src.logo,
    title: src.title ?? "",
    message: src.message ?? "",
    landingurl: getNotificationLandingUrl(src),
    type: src.type,
    payload: src.payload,
    notificationType: raw.notificationType ?? src.notificationType,
  };
}

function dispatchFlutterBroadcastFromEvent(e) {
  const notification = normalizeFlutterFCMNotificationDetail(e.detail);
  if (!notification) return;
  const type =
    typeof notification.notificationType === "string"
      ? notification.notificationType.toLowerCase()
      : "";
  // QUICK_ASSIST hamesha seedha redirect karta hai (foreground ho ya background),
  // modal nahi dikhta.
  const isQuickAssist = notification.type === "QUICK_ASSIST";
  if (isQuickAssist || REDIRECT_ONLY_NOTIFICATION_TYPES.has(type)) {
    if (notification.landingurl) {
      applyQuickAssistTicketId(notification);
      applyOrderTypeFromUrl(notification.landingurl);
      window.location.assign(notification.landingurl);
    }
    return;
  }
  if (!notification.title && !notification.message) return;
  store.dispatch(openFlutterBroadcastModal(notification));
}

["flutterFCMNotification", "flutter-fcm"].forEach((eventName) => {
  window.addEventListener(eventName, dispatchFlutterBroadcastFromEvent);
});

if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    const data = event.data || {};
    if (data.type === "FCM_NOTIFICATION_NAVIGATE" && data.url) {
      // data.type yahan "FCM_NOTIFICATION_NAVIGATE" hai, isliye SW se aaya
      // notificationType hi asli FCM type hai.
      applyQuickAssistTicketId({
        type: data.notificationType,
        payload: data.payload,
      });
      applyOrderTypeFromUrl(data.url);
      window.location.assign(data.url);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

reportWebVitals();